<right-panel-action
    [icon]="starred ? 'dku-icon-star-outline-24' : 'dku-icon-star-fill-24'"
    [tooltip]="starred ? INTEREST_WORDING.tooltips.UNSTAR : INTEREST_WORDING.tooltips.STAR"
    [disabled]="disabled"
    [disabledTooltip]="disabledTooltip"
    (clicked)="starredChange.emit(!starred)"
>
    {{starred ? INTEREST_WORDING.labels.UNSTAR : INTEREST_WORDING.labels.STAR}}
</right-panel-action>